<template>
  <UiTable
    :storage-id="storageId"
    :source-columns="columns"
    :rows="rows"
    :is-loading="isLoading"
    :pagination="{ 'page-index': page, 'page-size': pageSize }"
    :table-props="{ 'cell-style-option': cellStyleOption }"
    :total="total"
    v-on="paginationListeners"
  />
</template>

<script>
import { PaymentsService } from '@/services/payments.service'
import { redirectIfDenied } from '@/services/ability.service'

import tableDefaults from '@/components/table/tableDefaults'

import columns from './columns.js'

import UiTable from '@/components/table/UiTable.vue'
import syncQuery from '@/mixins/syncUrlQuery'

export default {
  components: { UiTable },
  mixins: [syncQuery, columns, tableDefaults],
  data() {
    return {
      storageId: 'payments-table',
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          const styles = {
            error: 'row-error',
            success: 'row-success',
          }

          const rowColor = row.appId ? styles.success : styles.error

          return rowColor
        },
      },
    }
  },
  watch: {
    '$route.query': {
      handler: 'getPaymentsList',
      immediate: true,
    },
  },
  mounted() {
    this.syncQuery({ localField: 'pageSize', queryField: 'pageSize', query2local: (v) => +v })
    this.syncQuery({ localField: 'page', queryField: 'page', query2local: (v) => +v })
  },
  methods: {
    /**
     * Send request to backend for get list of payments
     *
     * @returns {Object} data Response wrapper. Contains `content` and `total` parameters.
     * */
    async getPaymentsList() {
      this.isLoading = true

      try {
        const { data } = await PaymentsService.getList(this.colletQueryParams())

        this.rows = data.content
        this.total = data.total
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message

        redirectIfDenied.call(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
